/**
 * Product selector archive: inject selector promo card into Algolia hits list.
 */
(function() {
  const CARD_TEMPLATE_ID = "wlc-product-selector-card-template";
  const MARK_ATTR = "data-product-selector";
  const CTA_SELECTOR = "a.button-selector";

  function getCardTitle() {
    if (
      typeof wlcInstantsearchData !== "undefined" &&
      wlcInstantsearchData.product_selector_card_title
    ) {
      return wlcInstantsearchData.product_selector_card_title;
    }

    return "Don't know what to choose?";
  }

  function pushArchiveCtaEvent() {
    window.dataLayer = window.dataLayer || [];

    const payload = {
      event: "product_selector_archive_cta"
    };
    const category =
      typeof wlcInstantsearchData !== "undefined" &&
      wlcInstantsearchData.current_category
        ? wlcInstantsearchData.current_category
        : null;

    if (category && category.id != null) {
      // eslint-disable-next-line camelcase
      payload.term_id = Number(category.id) || 0;
    }

    if (category && typeof category.name === "string" && category.name) {
      // eslint-disable-next-line camelcase
      payload.category_name = category.name;
    }

    if (category && typeof category.slug === "string" && category.slug) {
      // eslint-disable-next-line camelcase
      payload.category_slug = category.slug;
    }

    window.dataLayer.push(payload);
  }

  function bindArchiveCtaTracking(li) {
    if (!li || li.getAttribute("data-ps-cta-tracked") === "1") {
      return;
    }

    li.setAttribute("data-ps-cta-tracked", "1");
    li.addEventListener("click", function(e) {
      const link = e.target.closest && e.target.closest(CTA_SELECTOR);

      if (!link || !li.contains(link)) {
        return;
      }

      pushArchiveCtaEvent();
    });
  }

  function createArchiveCardLiFromTemplate() {
    const tpl = document.getElementById(CARD_TEMPLATE_ID);

    if (!tpl || !tpl.content) {
      return null;
    }

    const fragment = tpl.content.cloneNode(true);
    const li = fragment.querySelector("li.ais-Hits-item");

    return li || null;
  }

  function createArchiveCardLiProgrammatic() {
    const li = document.createElement("li");

    li.className = "ais-Hits-item --product-selector";
    li.setAttribute(MARK_ATTR, "true");

    const card = document.createElement("div");

    card.className =
      "category-product-card category-product-card--product-selector";
    card.setAttribute("role", "region");

    const p = document.createElement("p");

    p.className = "category-product-card__selector-label";
    p.textContent = getCardTitle();

    card.appendChild(p);
    li.appendChild(card);

    return li;
  }

  function mountArchiveCard(event) {
    const containerSelector =
      (event && event.detail && event.detail.containerSelector) ||
      "#hits-products-tytan-professional";
    const container = document.querySelector(containerSelector);

    if (!container) {
      return;
    }

    const list = container.querySelector(".ais-Hits-list");

    if (!list) {
      return;
    }

    list.querySelectorAll("li[" + MARK_ATTR + "]").forEach(el => {
      el.remove();
    });

    const productItems = list.querySelectorAll(
      ".ais-Hits-item:not([" + MARK_ATTR + "])"
    );

    if (productItems.length === 0) {
      return;
    }

    const li =
      createArchiveCardLiFromTemplate() || createArchiveCardLiProgrammatic();
    const ref = list.children[2] || null;

    list.insertBefore(li, ref);
    bindArchiveCtaTracking(li);
  }

  window.addEventListener("wlcAlgoliaCategoryArchiveRender", mountArchiveCard);
  // Category archive may finish its first render before this dependent script runs.
  mountArchiveCard({
    detail: { containerSelector: "#hits-products-tytan-professional" }
  });
})();
